import { computed } from 'vue';
import { useFunctionGetter } from 'dashboard/composables/store';
import { INBOX_TYPES } from 'dashboard/helper/inbox';

/**
 * The contact phone number is the source_id of its WhatsApp contact inboxes, so
 * changing it once a WhatsApp conversation exists orphans that conversation.
 * Callers use the returned flag to disable the phone number field.
 *
 * The conversations must already be in the store — this composable only reads
 * `contactConversations`, it never dispatches the fetch, so that mounting a form
 * per contact (e.g. the contacts list cards) does not trigger one request each.
 *
 * @param {import('vue').Ref<number|string>|import('vue').ComputedRef} contactId
 * @returns {{ isPhoneNumberLocked: import('vue').ComputedRef<boolean> }}
 */
export function useContactPhoneLock(contactId) {
  const conversations = useFunctionGetter(
    'contactConversations/getAllConversationsByContactId',
    contactId
  );

  const isPhoneNumberLocked = computed(() =>
    conversations.value.some(
      conversation => conversation.meta?.channel === INBOX_TYPES.WHATSAPP
    )
  );

  return { isPhoneNumberLocked };
}
